import OrganizationDto from '@/common/classes/dto/OrganizationDto'

/**
 * @type {Map<Number, Array<Number>>}
 */
const nationalityIdToSubjectIdsMap = new Map()
let cachedNationalityId = null

export default class NationalityIdChanged {
  getNationalityIdToSubjectIdsMap() {
    return nationalityIdToSubjectIdsMap
  }

  /**
   * @param {OrganizationDto} organization
   * @returns {Promise<OrganizationDto>}
   */
  trigger(organization) {
    const nationality_id = Number(organization.nationality_id)
    const subjectIds = this.getNationalityIdToSubjectIdsMap().get(nationality_id) ?? []
    let subject_id = organization.subject_id
    cachedNationalityId = cachedNationalityId ?? nationality_id
    if (cachedNationalityId !== nationality_id) {
      cachedNationalityId = nationality_id
      if (!subjectIds.includes(subject_id)) {
        subject_id = subjectIds[0] ?? subject_id
      }
      organization = { nationality_id, subject_id }
      organization = new OrganizationDto(organization)
    }

    return Promise.resolve(organization)
  }
}
